import { makeStyles } from "tss-react/mui";
import { MiChip } from "@miplatform/components";
import { HOME_PHASE_MAP, TYPOGRAPHY_VARIANTS } from "@miplatform/constants";
import { Typography } from "@mui/material";
import { Box } from "@mui/system";

interface HomeCardTitleProps {
  home: any;
}

type colorType =
  | "default"
  | "success"
  | "error"
  | "primary"
  | "secondary"
  | undefined;

export function HomeCardTitle({ home }: HomeCardTitleProps) {
  const { classes } = useStyles();

  const getHomeChip = (phase: string) => {
    const { text, color } = HOME_PHASE_MAP[phase];
    return (
      <MiChip
        color={color as colorType}
        label={text}
        size="small"
        variant="outlined"
        className={classes.chip}
      />
    );
  };

  return (
    <Box className={classes.container}>
      <Typography variant={TYPOGRAPHY_VARIANTS.HD2} className={classes.address}>
        {home?.address?.addressLine1 || " "}
      </Typography>

      {home?.phase && getHomeChip(home?.phase)}
    </Box>
  );
}

const useStyles = makeStyles()((theme) => ({
  container: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(2),
  },
  address: {
    color: theme.palette.primary.main,
  },
  chip: {
    borderRadius: theme.spacing(1),
    fontSize: theme.typography.caption.fontSize,
    backgroundColor: theme.palette.grey.mediumLight,
    height: 14,
  },
}));
